import FrameDialog from "../../../ui/containers/FrameDialog";
import FrameHeader from "../../../ui/containers/FrameHeader";
import { useState } from "react";
import FrameDialogContent from "../../../ui/containers/FrameDialogContent";
import { Fab, Typography } from "@mui/material";
import EntryList from "../../entry/EntryList";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import FloatingActions from "../../../ui/FloatingActions";
import { useDispatch } from "react-redux";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { createNode } from "../../../lib/list";
import { attachNode } from "../../../store/list-slice";


function sortingFn(a, b) {
	return a.toLowerCase()
		.localeCompare(b.toLowerCase());
}


function NewRegimentButton({ faction, type, filter, promoted }) {
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch();

	function handleClose() {
		setOpen(false);
	}

	function handleOpen() {
		setOpen(true);
	}

	function handleEntrySelect(entry) {
		const node = createNode({
			type,
			entrySlug: entry.slug,
		});

		dispatch(attachNode({ path: "", node }));
		handleClose();
	}

	let regimentSlugs = [];
	regimentSlugs.push(...faction.entryGroups.find(g => g.slug === type).entrySlugs);
	if (type === "mainstay") {
		regimentSlugs.push(...promoted);
	} else if (type === "restricted") {
		regimentSlugs = regimentSlugs.filter(s => !promoted.includes(s));
	}
	regimentSlugs = regimentSlugs.filter(s => !filter.includes(s));


	const regiments =
		[...regimentSlugs].sort(sortingFn).map(s => faction.entries[s]);

	const actions = [
		{
			id: "close",
			icon: ArrowBackIcon,
			handler: handleClose,
		}
	];

	let singularName = "Regiment";
	let pluralName = "Regiments";
	if (type === "heroes") {
		singularName = "Hero";
		pluralName = "Heroes";
	} else if (type === "monsters") {
		singularName = "Monster";
		pluralName = "Monsters";
	}

	return (
		<>
			<Fab
				color="primary"
				variant="extended"
				sx={{ alignSelf: "center" }}
				size="large"
				onClick={handleOpen}
			>
				<AddCircleIcon sx={{ mr: 1 }} />
				<Typography variant="h5">{singularName}</Typography>
			</Fab>
			<FrameDialog
				open={open}
				onClose={handleClose}
				responsive
				color="darkBgr"
				actions={actions}
			>
				<FrameHeader title={`Select ${singularName}`} />
				<FrameDialogContent>
					<EntryList
						title={pluralName}
						entries={regiments}
						onEntrySelect={handleEntrySelect}
						factionSlug={faction.slug}
					/>
				</FrameDialogContent>
			</FrameDialog>
		</>
	);
}


export default NewRegimentButton;